import { render, staticRenderFns } from "./AdaptiveIframe.vue?vue&type=template&id=4a0bfe13&scoped=true"
import script from "./AdaptiveIframe.vue?vue&type=script&lang=js"
export * from "./AdaptiveIframe.vue?vue&type=script&lang=js"
import style0 from "./AdaptiveIframe.vue?vue&type=style&index=0&id=4a0bfe13&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0bfe13",
  null
  
)

export default component.exports